import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class PushPinIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 32 32"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					 transformOrigin: "center"
				 }}>
				<g style={{transform: "rotate(-45deg)", transformOrigin: "center"}}>
					<path
						d="M 1.096789,30.972481 1.9414899,28.684654 11.497,19.13 4.959,12.592 5.666,11.885 c 1.517,-1.517 3.225,-2.447 4.939,-2.689 1.513,-0.214 2.959,0.141 4.163,1.006 L 17.951,7.019 C 16.811,5.05 17.777,2.466 19.533,0.71 l 0.707,-0.707 11.798,11.798 -0.707,0.707 c -0.962,0.962 -2.175,1.669 -3.328,1.938 -1.096,0.257 -2.123,0.128 -2.977,-0.36 l -3.179,3.179 c 0.99,1.331 1.337,2.881 1.006,4.534 -0.314,1.568 -1.26,3.204 -2.663,4.608 l -0.707,0.707 -6.571,-6.571 -9.5568253,9.555968 z M 7.823,12.628 19.446,24.251 c 0.754,-0.926 1.258,-1.912 1.445,-2.843 0.262,-1.31 -0.113,-2.482 -1.116,-3.485 l -0.707,-0.707 5.864,-5.864 0.707,0.707 c 0.477,0.477 1.118,0.625 1.908,0.44 0.528,-0.124 1.084,-0.389 1.604,-0.757 L 20.305,2.896 c -0.757,1.08 -1.272,2.557 -0.322,3.506 l 0.707,0.707 -5.864,5.864 -0.707,-0.707 C 13.22,11.367 12.132,11 10.886,11.176 9.878,11.318 8.816,11.825 7.823,12.628 Z"
						style={{
							stroke: "#000000",
							strokeWidth: 0.5,
							strokeOpacity: 1
						}}/>
					<path
						d="m 8.6727352,15.820312 c 0.2850204,-2.082607 1.2815164,-3.513756 2.7335148,-3.925821 0.370848,-0.105244 0.740633,-0.144301 1.367187,-0.144403 L 13.3125,11.75 V 8 4.25 L 12.835937,4.2497625 C 12.573828,4.2496341 12.267969,4.2349513 12.15625,4.2171355 11.374562,4.0924798 10.776916,3.3632155 10.4694,2.1587944 10.434667,2.0227614 10.40625,1.8891953 10.40625,1.8619808 c 0,-0.044956 0.510187,-0.049481 5.579541,-0.049481 h 5.579541 l -0.02117,0.1171875 C 21.510472,2.1161686 21.377958,2.559977 21.289912,2.7812032 21.08692,3.2912416 20.721987,3.777339 20.374831,4.0001085 20.090334,4.1826696 19.895283,4.2243589 19.242187,4.2421942 L 18.65625,4.2581958 V 8.0040978 11.75 l 0.554687,9.4e-5 c 0.601691,9.3e-5 0.991005,0.03676 1.34142,0.126341 1.46069,0.373404 2.415824,1.678175 2.744074,3.748571 0.02589,0.163281 0.04712,0.307421 0.04719,0.320312 6.3e-5,0.01289 -3.305423,0.02344 -7.345539,0.02344 l -7.3456646,-6e-6 z"
						transform="matrix(0.78957596,0.78992736,-0.7832259,0.78287749,13.526802,-6.7184361)"
						style={{
							fill: this.props.color,
							fillRule: "evenodd",
							fillOpacity: 0.5
						}}/>
				</g>
			</svg>
		);
	}
}